import React from 'react'
import { Link } from "react-router-dom";
import * as routes from "../constants/routes";

import "./Home.css"

const LandingPage = () => {
  return (
    <div className="app">
      <h1 className="white">Bem-vindo(a)!</h1>
      <p className="white center">Neste exato momento você está acessando uma Web App de Jogo de Cartas, no qual são promovidos desafios que testam suas habilidades!</p>
      <p className="white center">Então presta muita atenção, pois jogos de cartas são games de estratégia nos quais os participantes criam baralhos de jogo personalizados para solucionarem os desafios propostos.</p>
      <p className="white center">Preparado para decolar nessa aventura?</p>
      <p className="white center">Basta clicar no botão "Iniciar" logo abaixo!</p>
      <br></br>
      <Link className="white btn-start link" to={routes.HOME}>Iniciar</Link>
    </div>
  )
}

export default LandingPage



// WEBPACK FOOTER //
// ./src/components/Landing.js